import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useBluelagoon } from "@bluelagoon";
import { Button } from "@shadcn-in-nx/ui/button";
import { Input } from "@shadcn-in-nx/ui/input";
import { Loader2, Plus } from "lucide-react";
import WorkflowSelector from "./WorkflowSelector";

export default function AutomationFields({ workflowId, setWorkflowId, stepId, setStepId }) {
    const { t } = useTranslation();
    const [creating, setCreating] = useState(false);
    const { call: createWorkflow } = useBluelagoon({ method: "createWorkflow" });

    const handleCreateWorkflow = useCallback(async () => {
        setCreating(true);
        const result = await createWorkflow({ name: `Playground Test ${Date.now()}` });
        setCreating(false);
        const id = result?.workflowId || result?.workflow?.id;
        if (id) setWorkflowId(id);
    }, [createWorkflow, setWorkflowId]);

    const handleSelectWorkflow = useCallback((wf) => {
        setWorkflowId(wf.id);
    }, [setWorkflowId]);

    return (
        <div className="grid grid-cols-2 gap-3">
            <div>
                <label className="text-sm font-medium text-slate-700">
                    {t("admin.automationPlayground.workflowId")}
                </label>
                <div className="mt-1 space-y-2">
                    <WorkflowSelector onSelect={handleSelectWorkflow} />
                    <div className="flex gap-2">
                        <Input value={workflowId} onChange={(e) => setWorkflowId(e.target.value)}
                            placeholder="clx..." className="flex-1 text-xs font-mono" />
                        <Button type="button" variant="outline" size="sm" onClick={handleCreateWorkflow} disabled={creating}>
                            {creating ? <Loader2 className="h-4 w-4 animate-spin" />
                                : <><Plus className="h-4 w-4 mr-1" /> {t("admin.automationPlayground.createWorkflow")}</>}
                        </Button>
                    </div>
                </div>
            </div>
            <div>
                <label className="text-sm font-medium text-slate-700">{t("admin.automationPlayground.stepId")}</label>
                <Input value={stepId} onChange={(e) => setStepId(e.target.value)}
                    placeholder={t("admin.automationPlayground.stepIdPlaceholder")} className="mt-1" />
            </div>
        </div>
    );
}
